<style lang="scss" scoped>
.dropdown-item {
  &[disabled] {
    opacity: 0.5;
  }

  &:hover {
    cursor: pointer;

    &[disabled] {
      cursor: not-allowed;
    }
  }
}

::v-deep .modal-dialog {
  max-width: 800px;
}
</style>

<template>
  <td>
    <div ref="dropdown" class="dropdown dropleft" :class="{ show: show }">
      <button
        @click="show = !show"
        class="btn btn-secondary dropdown-toggle"
        type="button"
      >
        Aktionen
      </button>
      <div class="dropdown-menu" :class="{ show: show }">
        <div class="dropdown-item" @click="logout" :disabled="loggingOut">
          Moderator aus dem Chat ausloggen
        </div>
        <div class="dropdown-item" @click="showModal = true">
          Moderator anschreiben
        </div>
      </div>
    </div>
    <v-modal v-if="showModal" :show.sync="showModal">
      <h4 slot="header" class="title title-up">Moderator anschreiben</h4>
      <admin-support-message-resource
        :moderatorId="model.id"
        :noTitle="true"
      ></admin-support-message-resource>
    </v-modal>
  </td>
</template>

<script lang="babel">
import { catchOutsideClicks } from "@/js/bodyClick.js";
import { Modal } from "src/components/UIComponents";
import AdminSupportMessageResource from "@/components/resources/AdminSupportMessageResource";

export default {
    components: {
      AdminSupportMessageResource,
      'v-modal': Modal
    },
    props: ['content', 'label', 'model'],
    data() {
      return {
        show: false,
        loggingOut: false,
        showModal: false
      };
    },
    mounted() {
      catchOutsideClicks(this.$refs.dropdown, () => {
        this.show = false;
      });
    },
    methods: {
      logout() {
        this.loggingOut = true;
        this.$http.post("/api/v1/moderator/chat-logout", { id: this.model.user.id });
      }
    }
};
</script>
